import { supabase } from "./core.js";
import type { Notification } from "../types/index.js";

export async function fetchNotifications(clientId: string): Promise<Notification[]> {
  const { data, error } = await supabase
    .from("notifications")
    .select("id, client_id, type, title, message, read, created_at")
    .eq("client_id", clientId)
    .order("created_at", { ascending: false });
  if (error) throw error;
  return (data || []) as unknown as Notification[];
}

export async function markNotificationsRead(clientId: string): Promise<void> {
  const { error } = await supabase
    .from("notifications")
    .update({ read: true })
    .eq("client_id", clientId)
    .eq("read", false);
  if (error) throw error;
}

export async function createNotification(
  clientId: string,
  type: string,
  title: string,
  message: string
): Promise<void> {
  const { error } = await supabase.from("notifications").insert({
    client_id: clientId,
    type,
    title,
    message,
    read: false,
  });
  if (error) throw error;
}
